<template>
	<div class="package-add-page">

		<!-- ===== 面包屑 + 返回 ===== -->
		<div class="breadcrumb-bar animate__animated animate__fadeIn" @click="back()">
			<div class="bc-left">
				<span class="bc-label">{{$t('header.breadcrumb.label')}}</span>
				<span class="bc-item">{{$t('userPageL.txt4')}}</span>
				<el-image class="bc-arrow" :src="require('@/static/CodeBuddyAssets/30868_4786/24.svg')"></el-image>
				<span class="bc-item bc-active" v-if="!id">{{$t('packageAdd.t1')}}</span>
				<span class="bc-item bc-active" v-if="id">{{$t('packageAdd.t2')}}</span>
			</div>
			<div class="bc-right">
				<span class="bc-back-text">{{$t('header.breadcrumb.backBtn')}}</span>
				<el-image class="bc-back-icon" :src="require('@/static/CodeBuddyAssets/30868_4786/25.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 表单卡片 ===== -->
		<div class="form-card animate__animated  ">
			<!-- 基本信息 -->
			<div class="section-header">
				<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/30868_4786/28.svg')"></el-image>
				<h3 class="sec-title">{{$t('packageAdd.t3')}}</h3>
			</div>

			<div class="form-row">
				<div class="form-col-left">
					<div class="form-item">
						<label class="form-label">{{$t('packageAdd.t4')}}</label>
						<div class="form-input-wrap">
							
							<!-- 多语言 -->
							<template v-if="$i18n.locale=='zh'">
								<el-select v-model="warehouse" :placeholder="$t('packageAdd.t6')" class="form-select">
									<el-option v-for="item in warehouseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</template>
							<template v-if="$i18n.locale=='en'">
								<el-select v-model="warehouse" :placeholder="$t('packageAdd.t6')" class="form-select">
									<el-option v-for="item in warehouseOptions" :key="item.value" :label="item.nameEn" :value="item.value"></el-option>
								</el-select>
							</template>
							
							
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">{{$t('packageAdd.t5')}}</label>
						<div class="form-input-wrap country-field">
							<div class="country-trigger" @click="toggleCountryPanel">
								<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
								<span v-else class="country-trigger-placeholder">{{$t('packageAdd.t6')}}</span>
								<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
							</div>
							<!-- 国家弹出选择面板：搜索框 + 字母索引 -->
							<div class="country-panel" v-show="showCountryPanel" @click.stop>
								<div class="country-search">
									<el-input v-model="searchKeyword" :placeholder="$t('packageAdd.t7')" class="country-search-input" clearable>
										<i slot="prefix" class="el-icon-search"></i>
									</el-input>
								</div>
								<div class="country-body">
									<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
										<template v-for="group in filteredCountries">
											<div class="country-group" :key="group.letter" :data-letter="group.letter">
												<div class="country-group-title">{{group.letter}}</div>
												<div class="country-item" :class="{ active: country === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
													
													<!-- 多语言 -->
													<template v-if="$i18n.locale=='zh'">
														<span class="country-name">{{item.label}}</span>
													</template>
													<template v-if="$i18n.locale=='en'">
														<span class="country-name">{{item.nameEn}}</span>
													</template>
													
												</div>
											</div>
										</template>
										<div v-if="filteredCountries.length === 0" class="country-empty">{{$t('packageAdd.t8')}}</div>
									</div>
									<div class="country-index">
										<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="form-col-right">
					<div class="form-item">
						<label class="form-label">{{$t('packageAdd.t9')}}</label>
						<div class="form-input-wrap">
							<el-select v-model="mark" :placeholder="$t('packageAdd.t6')" class="form-select">
								<el-option v-for="item in maitouOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>

			<!-- 商品信息 -->
			<div class="section-header">
				<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/30868_4786/29.svg')"></el-image>
				<h3 class="sec-title">{{$t('packageAdd.t10')}}</h3>
				<div class="sec-collapse" @click="goodsOpen = !goodsOpen">
					<span>{{ goodsOpen ? $t('packageAdd.t11') : $t('packageAdd.t12') }}</span>
					<el-image :class="{ 'collapse-rotated': !goodsOpen }" :src="require('@/static/CodeBuddyAssets/30868_4786/30.svg')"></el-image>
				</div>
			</div>

			<div class="goods-area" v-if="goodsOpen">
				<template v-for="(gitem,gindex) in goodsArr">
				<div class="form-row">
					<div class="form-col-left">
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t13')}}</label>
							<div class="form-input-wrap">
								<el-input v-model="gitem.name" :placeholder="$t('packageAdd.t14')" size="large"></el-input>
							</div>
						</div>
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t15')}}</label>
							<div class="form-input-wrap">
								<el-input v-model="gitem.cost" :placeholder="$t('packageAdd.t16')" size="large"></el-input>
							</div>
						</div>
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t17')}}</label>
							<div class="form-input-wrap">
								<el-input v-model="gitem.expressNumber" :placeholder="$t('packageAdd.t18')" size="large"></el-input>
							</div>
						</div>
					</div>
					<div class="form-col-right">
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t19')}}</label>
							<div class="form-input-wrap">
								<el-input v-model="gitem.pieceNum" :placeholder="$t('packageAdd.t20')" size="large"></el-input>
							</div>
						</div>
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t21')}}</label>
							<div class="form-input-wrap">
								
								
								<!-- 多语言 -->
								<template v-if="$i18n.locale=='zh'">
									<el-select v-model="gitem.itemCategory" multiple :placeholder="$t('packageAdd.t22')" class="form-select">
										<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</template>
								<template v-if="$i18n.locale=='en'">
									<el-select v-model="gitem.itemCategory" multiple :placeholder="$t('packageAdd.t22')" class="form-select">
										<el-option v-for="item in categoryOptions" :key="item.value" :label="item.nameEn" :value="item.value"></el-option>
									</el-select>
								</template>
								
								
							</div>
						</div>
						<div class="form-item">
							<label class="form-label">{{$t('packageAdd.t23')}}</label>
							<div class="form-input-wrap">
								<el-input v-model="gitem.remark" :placeholder="$t('packageAdd.t24')" size="large"></el-input>
							</div>
						</div>
					</div>
				</div>
				</template>
			</div>

			<!-- 底部按钮 -->
			<div class="form-actions" v-if="!id">
				<div class="action-btn btn-add-pkg" @click="addPackage">{{$t('packageAdd.t1')}}</div>
			</div>
		
			</div>
	
			<!-- 底部按钮 -->
			<div class="form-actions" style="justify-content: flex-end;" v-if="!id">
			<div class="action-btn btn-batch" @click="link('/userPageLab/packageAddMore')">{{$t('packageAdd.t25')}}</div>
			<div class="action-btn btn-submit" @click="submitYb" style="margin: 0;">{{$t('packageAdd.t26')}}</div>
			</div>
	
			<div class="form-actions" style="justify-content: flex-end;" v-if="id">
			<div class="action-btn btn-submit" @click="submitYb" style="margin: 0;">{{$t('packageAdd.t27')}}</div>
			</div>
		
	</div>
</template>

<script>
import { 
	packageforecast,
	warehouselist, 
	countrylist, 
	packageGoodsTypeList,
	memberMarklist,
	packagedetail,
	packageedit,
} from "/src/api/api.js"
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	name: 'PackageAdd',
	data() {
		return {
			id:0,
			pmsg:'',
			goodsOpen: true,
			mark: '',
			country: '',
			warehouse: '',
			warehouseOptions: [],
			countryOptions: [],
			categoryOptions: [],
			maitouOptions:[],
			// 国家选择面板
			countryArr: [],
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
			// 包裹列表
			goodsArr:[
				{
					expressNumber:'',
					name: '',
					cost: '',
					pieceNum: '',
					remark: '',
					itemCategory: [],
				}
			],
		}
	},
	computed: {
		// 当前选中国家名称
		selectedCountryName() {
			const item = this.countryArr.find(c => c.value === this.country)
			// 多语言
			if(this.$i18n.locale=='zh'){
				return item ? (item.label || item.name) : ''
			}
			if(this.$i18n.locale=='en'){
				return item ? (item.nameEn || item.name) : ''
			}
		},
		// 按首字母分组 + 搜索过滤后的列表
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.countryArr
			if (kw) {
				list = list.filter(item => String(item.label || item.name || '').toLowerCase().indexOf(kw) > -1)
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（不随搜索变化）
		availableLetters() {
			const set = []
			this.countryArr.forEach(item => {
				const l = this.getFirstLetter(item.label || item.name)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	mounted() {
		this.id = this.$route.query.id
		if(this.id){
			this.packagedetailF()
		}
		// 基础数据
		this.getmemberMarklist()
		this.loadWarehouses()
		this.loadCountries()
		this.loadCategories()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	methods: {
		// 详情
		async packagedetailF() {
			const res = await packagedetail({id:this.id})
			if (res.code == 200) {
				res.data.goodsType = res.data.goodsType||[]
				this.pmsg = res.data
				this.goodsArr = [{
					expressNumber: res.data.expressNumber||'',
					name: res.data.name||'',
					cost: res.data.cost||'',
					pieceNum: res.data.pieceNum||'',
					remark: res.data.remark||'',
					// 货物类型
					itemCategory:res.data.goodsType,
				}]
				this.mark = res.data.memberMarksId
				this.country = res.data.countryId
				this.warehouse = res.data.warehouseId
				// this.OPitem = this.goodsArr[0]
				// if(res.data.memberMarksId){
				// 	this.mtMsg={
				// 		id:res.data.memberMarksId
				// 	}
				// 	this.marking=res.data.memberMarks
				// }
				// (res.rows || []).forEach(item => {
				// 	item.label = item.memberMarks
				// 	item.value = item.id
				// })
				// this.maitouOptions = res.rows
			} else {this.Tips(res.msg, 'error')}
		},
		// 唛头列表
		async getmemberMarklist() {
			const res = await memberMarklist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.memberMarks
					item.value = item.id
				})
				this.maitouOptions = res.rows
			} else {
				this.Tips(res.msg || this.$t('packageAdd.t28'), 'error')
			}
		},
		// 仓列表
		async loadWarehouses() {
			const res = await warehouselist({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.warehouseOptions = res.rows
			} else {
				this.Tips(res.msg || this.$t('packageAdd.t29'), 'error')
			}
		},
		// 国家
		async loadCountries() {
			const res = await countrylist({})
			if (res.code == 200) {
				var countryArr = []
				;(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
					countryArr.push(item)
				})
				this.countryOptions = res.rows
				this.countryArr = countryArr
			} else {
				this.Tips(res.msg || this.$t('packageAdd.t30'), 'error')
			}
		},
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家
		selectCountry(item) {
			this.country = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.$refs.countryList
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.$refs.countryList
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label || item.name)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const field = this.$el.querySelector('.country-field')
			if (field && !field.contains(e.target)) {
				this.showCountryPanel = false
			}
		},
		// 品类
		async loadCategories() {
			const res = await packageGoodsTypeList({})
			if (res.code == 200) {
				(res.rows || []).forEach(item => {
					item.label = item.name
					item.value = item.id
				})
				this.categoryOptions = res.rows
			} else {
				this.Tips(res.msg || this.$t('packageAdd.t31'), 'error')
			}
		},
		addPackage() {
			// 添加包裹
			this.goodsArr.push({
				expressNumber: '',
				name: '',
				cost: '',
				pieceNum: '',
				remark: '',
				itemCategory: [],
			})
		},
		// 提交预报
		async submitYb(){
			if(!this.warehouse){
				this.Tips(this.$t('packageAdd.t32'));
				return;
			}
			if(!this.country){
				this.Tips(this.$t('packageAdd.t33'));
				return;
			}
			if(!this.mark){
				this.Tips(this.$t('packageAdd.t34'));
				return;
			}
			var data = []
			var noexpressNumber = false
			this.goodsArr.forEach((item)=>{
				if(!item.expressNumber){
					noexpressNumber = true
				}
				data.push({
					countryId:this.country,
					warehouseId:this.warehouse,
					memberMarksId:this.mark,
					expressNumber:item.expressNumber,
					name:item.name,
					pieceNum:item.pieceNum,
					cost:item.cost,
					remark:item.remark,
					goodsType:item.itemCategory,
				})
			})
			if(noexpressNumber){
				this.Tips(this.$t('packageAdd.t18'))
				return
			}
			let res;
			if(this.id){
				var itm = data[0]
				itm.id = this.id
				itm.memberId = this.pmsg.memberId
				res = await packageedit(itm)
			}else{
				res = await packageforecast(data)
			}
			if(res.code==200){
				this.Tips(res.msg)
				this.back()
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
.package-add-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===== 页面顶部条 ===== */
.page-top-bar {
	width: 1596px;
	height: 88px;
	background: #fff;
	border-radius: 12px;
	margin: 24px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 32px;
	box-sizing: border-box;
}
.welcome-text { display: flex; align-items: baseline; }
.wel-gray { font-size: 20px; color: #666; font-weight: 400; }
.wel-blue { font-size: 20px; color: #0096FF; font-weight: 500; margin-left: 4px; }
.top-actions { display: flex; align-items: center; }
.lang-text { font-size: 16px; font-weight: 500; color: #333; }
.action-gap { width: 1px; height: 18px; margin: 0 16px; }
.user-name { font-size: 18px; color: #333; margin-left: 8px; }
.member-no { font-size: 18px; color: #989FAC; margin-left: 8px; }
.cart-badge { margin-left: -6px; margin-bottom: 12px; width: 10px; height: 10px; }

/* ===== 面包屑 ===== */
.breadcrumb-bar {
	width: 1596px;
	margin: 16px auto 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 4px;
	box-sizing: border-box;
}
.bc-left { display: flex; align-items: center; }
.bc-label { font-size: 16px; color: #333; }
.bc-item { font-size: 16px; color: #666; margin: 0 4px; }
.bc-item.bc-active { color: #0096FF; }
.bc-arrow { width: 14px; height: 14px; margin: 0 8px; }
.bc-right { display: flex; align-items: center; cursor: pointer; }
.bc-back-text { font-size: 16px; color: #0096FF; }
.bc-back-icon { width: 24px; height: 12px; margin-left: 6px; }

/* ===== 表单卡片 ===== */
.form-card {
	width: 1596px;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 32px 40px;
	box-sizing: border-box;
}

/* ===== 节标题 ===== */
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.sec-icon {
	width: 4px;
	height: 16px;
	margin-right: 12px;
}
.sec-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	flex: 1;
}
.sec-collapse {
	display: flex;
	align-items: center;
	cursor: pointer;
}
.sec-collapse span {
	font-size: 14px;
	color: #0096FF;
	letter-spacing: 0.5px;
}
.sec-collapse .el-image {
	width: 8px;
	height: 12px;
	margin-left: 4px;
	transition: transform 0.3s;
}
.collapse-rotated {
	transform: rotate(180deg);
}

/* ===== 表单行：两列 ===== */
.form-row {
	display: flex;
}
.form-col-left {
	width: 600px;
	flex-shrink: 0;
	margin-right: 44px;
}
.form-col-right {
	width: 600px;
	flex-shrink: 0;
}
.form-col-full {
	width: 100%;
}
.form-item {
	margin-bottom: 28px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
	width: 100%;
}
.form-input-wrap {
	width: 600px;
	::v-deep .el-select{
		width: 100%;
	}
}
.form-input-wrap--short {
	width: 466px;
	margin-right: 16px;
}
.form-input-wrap--wide {
	width: 1244px;
}

.form-input-wrap ::v-deep .el-input__inner,
.form-select ::v-deep .el-input__inner {
	height: 50px!important;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
	padding-left: 16px;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #C6C6C6;
}

.mark-select-btn {
	width: 118px;
	height: 50px;
	border: 1px solid #0096FF;
	border-radius: 4px;
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	font-weight: 500;
	color: #0096FF;
	cursor: pointer;
	flex-shrink: 0;
	box-sizing: border-box;
}

/* ===== 商品信息区域 ===== */
.goods-area {
	// overflow: hidden;
	// transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s;
	// max-height: 0;
	// opacity: 0;
}
.goods-area.goods-area-open {
	// max-height: 400px;
	// opacity: 1;
}

/* ===== 底部按钮 ===== */
.form-actions {
	display: flex;
	margin-top: 40px;
}
.action-btn {
	width: 184px;
	height: 60px;
	border-radius: 10px;
	text-align: center;
	line-height: 60px;
	font-size: 18px;
	font-weight: 500;
	cursor: pointer;
	margin-right: 16px;
	transition: background 0.3s;
}
.btn-add-pkg {
	background: #0096FF;
	color: #fff;
}
.btn-add-pkg:hover {
	background: #33ABFF;
}
.btn-batch {
	background: #fff;
	color: #0096FF;
	border: 1px solid #0096FF;
	box-sizing: border-box;
}
.btn-submit {
	background: #0096FF;
	color: #fff;
	margin-right: 0;
	margin-left: auto;
}
.btn-submit:hover {
	background: #33ABFF;
}

/* ===== 国家选择面板（搜索 + 字母索引） ===== */
.country-field {
	position: relative;
}
.country-trigger {
	width: 100%;
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	box-sizing: border-box;
	cursor: pointer;
	font-size: 16px;
	color: #333;
	.country-trigger-placeholder {
		color: #C6C6C6;
	}
	.country-trigger-arrow {
		color: #999;
		font-size: 12px;
		transition: transform 0.3s;
		&.arrow-up {
			transform: rotate(180deg);
		}
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	width: 640px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 12px;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 12px;
	::v-deep .el-input__inner {
		height: 40px;
		border: 1px solid #E2E6E9;
		border-radius: 4px;
		padding-left: 30px;
		font-size: 14px;
		color: #333;
	}
	::v-deep .el-input__inner:focus {
		border-color: #0096FF;
	}
	::v-deep .el-input__prefix {
		left: 8px;
		line-height: 40px;
		color: #92969F;
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 320px;
	overflow-y: auto;
	padding-right: 8px;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 13px;
	font-weight: 600;
	color: #0096FF;
	padding: 6px 10px;
}
.country-item {
	padding: 8px 10px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	border-radius: 4px;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 14px;
	padding: 40px 0;
}
.country-index {
	width: 36px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 320px;
	overflow-y: auto;
	border-left: 1px solid #F0F0F0;
}
.country-index-item {
	font-size: 12px;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 1px 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
</style>
